export const IsLike = (string, value) => {
    return string.toLowerCase().indexOf(value.toLowerCase()) > -1;
};

export const JobMatch = (job, searchStr) => {
    return (
        IsLike(job.id, searchStr) ||
        IsLike(job.func, searchStr) ||
        (job.args.length && IsLike(job.args[0], searchStr)) ||
        IsLike(job.name, searchStr)
    );
};

export const CronStyleScheduleTime = (job) => {
    let str = "";

    str += job.minute ? job.minute + " " : "* ";
    str += job.hour ? job.hour + " " : "* ";
    str += job.day ? job.day + " " : "* ";
    str += job.month ? job.month + " " : "* ";
    str += job.day_of_week ? job.day_of_week : "*";

    return str;
};

export const AddIsJsonValidation = (ValidatorForm) => {
    ValidatorForm.addValidationRule('isJson', (value) => {
        try {
            return value === "" || value === undefined || Boolean(JSON.parse(value));
        } catch (e) {}

        return false
    });
};

export const AddIsUrlValidation = (ValidatorForm) => {
    ValidatorForm.addValidationRule('isUrl', (value) => {
        var a  = document.createElement('a');
        a.href = value;
        return value === "" || (a.host && a.host !== window.location.host);
    });
};

export const isFormValid = (job, paramsToJson) => {
    try {
        job["args.1"] && (!paramsToJson || JSON.parse(job["args.1"]));
        job["kwargs.headers"] && JSON.parse(job["kwargs.headers"]);
    } catch (e) {
        return false;
    }

    return (
        job &&
        job.id &&
        job.name &&
        job.name.trim() &&
        job["args.0"] &&
        job.func &&
        job.trigger &&
        (job.trigger !== 'cron' || isCronDefined(job))
    );
};

export const isJobObjectValid = (job, paramsToJson) => {
    
    try {
        job.args.length <= 1 || (job.args[1] && (!paramsToJson || JSON.parse(job.args[1])));

        !job.kwargs.headers || (job.kwargs.headers && JSON.parse(job.kwargs.headers));
    } catch (e) {
        return false;
    }
    
    return (
        job &&
        job.id &&
        job.name &&
        job.name.trim() &&
        job.args.length &&
        job.args[0] &&
        job.func &&
        job.trigger &&
        (job.trigger !== 'cron' || isCronDefined(job))
    );
};

export const isCronDefined = (job) => {
    return job && (
        job.minute ||
        job.hour ||
        job.day ||
        job.month ||
        job.day_of_week ||
        job.year ||
        job.week ||
        job.second
    )
};



// WEBPACK FOOTER //
// ./src/components/helpers/JobHelpers.js